import BaseProxy from '@/proxies/Proxy';

class UserAccountProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('account', parameters);
  }
}

export default UserAccountProxy;



// WEBPACK FOOTER //
// ./src/proxies/user/AccountProxy.js